import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// initial state
const state: orgmap.state.OrgmapState = {
    user: Object.create(null),
    wish: [],
    members: {
        items: [],
        selectedAll: false,
        totalCount: 0,
    },
    selections: {
        dept: null,
        users: [],
    },
    departments: [],
    options: {
        useRetireSearch: false,
        addableDept: false,
        single: false,
        personal: true,
        selectFixedComcode: '',
        public: true,
        containers: [],
    },
    selectTreeItem: false,
    currentTab: 'hr',
    hr: {
        currentCompany: null,
        companies: [],
        dept: {
            items: [],
            current: null,
            path: [],
        },
        user: {
            // 사용자 목록
            items: [] as orgmap.UserItem[],
            // 현재 선택된 사용자 아이템
            current: null,
            // 사용자 목록에서 전체 선택 여부
            selectAll: false,
            totalCount: 0,
            // 선택된 사용자 개수
            usertotalCount: null,
        },
    },
    search: { query: null, totalCount: 0 },
}

export default {
    state,
    actions,
    getters,
    mutations,
}
